export function reportIdToDateTime(reportId) {
    if (!reportId || typeof reportId !== 'string') return '';

    const parts = reportId.split('-');
    const datetime = parts[parts.length - 1];

    const match = datetime.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})/);
    if (!match) return '';

    const [, year, month, day, hours, minutes, seconds] = match;
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}
